import React, { useState, useEffect, useReducer, useContext, useRef, useMemo } from 'react';
import { RowDataContext, RatePlanRowDataContext } from '../DynamicTable/productRestriction/contexts';

import { Box, Tooltip } from '@mui/material';
import TextField from '@mui/material/TextField';
import { Grid, Button, Modal, } from '@mui/material';
import {
    CloseSharp as CloseSharpIcon,
    ArrowBackIosNewSharp as ArrowBackIosNewSharpIcon,
    ArrowForwardIosSharp as ArrowForwardIosSharpIcon,
    CheckSharp as CheckSharpIcon,
    KeyboardArrowDown as KeyboardArrowDownIcon,
    KeyboardArrowUp as KeyboardArrowUpIcon
}
    from '@mui/icons-material';

import { useDispatch, useSelector } from 'react-redux';
import { updateAppState, getPropertyInfo } from '../../actions/appstate';
import DataService from "../../services/data.service";
import { deepCopy, dateFormat, isEmptyObj } from "../../app/util";
import "./update-restrictions-product-modal.scss";
import _ from 'lodash';

//Flag to track animation
const animatedFlags = {};

export default function UpdateRestrictionsProductModal(props) {
    const dateRowData = useContext(RowDataContext);
    const ratePlanRowData = useContext(RatePlanRowDataContext);
    const dateFormatted = dateFormat(dateRowData?.data.date, "ddd, MMM DD, YYYY");

    let { roomData, modalOpen, handleModalClose, compState, setCompState } = props;
    
    if ((compState?.entry?.cta || compState?.entry?.ctd || compState?.entry?.close) && compState?.entry?.open) {
        compState.entry.open = false;
        compState.open = false;
    }
    // debugger;
    const roomDataRef = useRef(deepCopy(props.roomData));
    const { recommended } = roomData?.restrictions || {};
    let { open, entry } = compState;
    const { auth } = useSelector(appState => appState);
    const { app_state, ui_state } = useSelector((state) => state.app.current_state);
    const { isRestrictionsRoomType } = app_state.workspace_controls;
    const property_info = getPropertyInfo(auth.profile.property_details, app_state.property_id);
    const hasExceptions = (property_info.permissions.restriction_exception === 1);

    const rOptionPermissions = property_info?.permissions?.restriction_m;
    //const rDataLevel = isRestrictionsRoomType ? 'room_type' : 'house';
    const rDataLevel = isRestrictionsRoomType;
    const rDataLevelOptionsPermissions = rOptionPermissions[rDataLevel] || {};
    const dataSource = property_info?.permissions?.restriction_s || 'Data Source';

    const [exceptions, setExceptions] = useState([
        { display: "CTA", value: "cta", active: false, open: false, exceptions: {} },
        { display: "CTD", value: "ctd", active: false, open: false, exceptions: {} },
        { display: "Close", value: "close", active: false, open: false, exceptions: {} },
    ])

    const compStateEntryRef = useRef(deepCopy(entry));

    const customTickIcon = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            fill="#606060"
            viewBox="0 0 256 256"
        >
            <path d="M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z"></path>
        </svg>
    );
    const customInfoIcon = (
        <svg
            className='info-icon'
            xmlns="http://www.w3.org/2000/svg"
            width="13" height="13" fill="#606060"
            viewBox="0 0 256 256"
        >
            <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"></path>
        </svg>
    );

    const handleClose = (data) => {
        let isRestrictionsChanged = false;
        const {restrictions} = roomDataRef.current;
        
        if(restrictions?.user_override.join()!== roomData?.restrictions?.user_override.join()){
            isRestrictionsChanged = true;
        }
        handleModalClose(data, isRestrictionsChanged);
    }
    const updateEntry = (key, updated_value) => {
        if (['cta', 'ctd', 'close'].includes(key)) {
            entry[key] = !entry[key];

            // Reset animation flag for cta, ctd, close
            if (entry[key] === false) {
                delete animatedFlags[key];
            }
        }
        if (entry.cta === true || entry.ctd === true || entry.close === true) {
            entry.open = false;
            delete animatedFlags.open; // Reset animation flag for open
        } else {
            entry.open = true;
        }
        if (updated_value || updated_value === 0) {
            //if (Number(updated_value) > 1) {
                entry[key] = updated_value;
            // }
            // if (Number(updated_value) <= 1) {
            //     delete entry[key];
            // }
        }

        //Checking equality
        let entryInit = deepCopy(compStateEntryRef.current);
        let entryNow = entry;
        if(!entry.open){
            delete entryInit.open; // Remove open key if true
            delete entryNow.open;
        }
        // if(['min_los', 'max_los'].includes(key)){
        //     if (Number(updated_value) <= 1) {
        //         delete entryInit[key];
        //         delete entryNow[key];
        //     }
        // }

        // entryInit = JSON.stringify(entryInit);
        // entryNow = JSON.stringify(entry);
        //let hasDifferences = entryInit !== entryNow;
        let hasDifferences = _.isEqual(entryInit, entry)
        if (Number(updated_value) <= 1) {
            delete entry[key];
        }
        setCompState(state => {
            return {
                ...state,
                open: entry.open,
                entry: entry,
                modified: !hasDifferences
            }
        })
        setExceptions(prev => {
            let indexOf = 0;
            let openIndex = prev.findIndex(i => i.open === true);
            prev = prev.map((i, index) => {
                if (i.value === key) {
                    i.active = entry[key];
                    i.open = entry[key];
                    indexOf = index;
                } else if (!entry[key] === false) {
                    i.open = false;
                }
                return i;
            });
            if (entry[key] === true && indexOf !== 0) {
                let temp = prev[0];
                prev[0] = prev[indexOf];
                prev[0].animate = "goUp";
                temp.animate = "goDown";
                prev[indexOf] = temp;
            }

            return prev;
        })
    }
    const handleOnChangeText = (type) => (e) => {
        let t = type;
        let prev = Number(compState.entry[type]);
        let value = Number(e.target.value);
        value = isNaN(value) ? 0 : value;
        e.target.value = value;
        updateEntry(type, value);
        //let entryInit = JSON.stringify(compStateEntryRef.current);
        //let entryNow = JSON.stringify(compState.entry);
        //let hasDifferences = entryInit !== entryNow;
        //if (prev !== value) {
        //    updateEntry(type, value);
        // } else {
        //     setCompState(state => {
        //         return {
        //             ...state,
        //             modified: hasDifferences
        //         }
        //     })
        // }

    }

    const renderExceptions = () => {
        return (
            <Grid className='restriction-popup-container-2' container spacing={1} mt={1}>
                {exceptions.map((res, exceptionIndex) => {
                    ['minadvance', 'maxadvance', 'minprice', 'maxprice', 'minlos', 'maxlos'].forEach((key) => {
                        if (!res.exceptions[key]) {
                            res.exceptions[key] = "";
                        }
                    })
                    return (
                        <Box onAnimationEnd={() => {
                            setExceptions(prev => {
                                prev = prev.map(i => {
                                    i.animate = "";
                                    return i;
                                })
                                return prev;
                            })
                        }} className={`restriction-exception-item ${res.animate}`}>
                            <Grid container spacing={2} className={`restriction-exception-header ${res.active && "active"}`}>
                                <Grid xs={10} className="restriction-popup-title-1" >
                                    {res.display} Exceptions
                                </Grid>
                                <Grid xs={2} >
                                    {res.open ?
                                        <KeyboardArrowUpIcon onClick={() => {
                                            setExceptions(prev => {
                                                prev = prev.map(i => {
                                                    if (i.value === res.value) {
                                                        i.open = false;
                                                    }
                                                    return i;
                                                })
                                                return prev;
                                            })
                                        }} style={{ float: "right", cursor: "pointer" }} />
                                        :
                                        <KeyboardArrowDownIcon onClick={() => {
                                            if (res.active) {
                                                setExceptions(prev => {
                                                    prev = prev.map((i, index) => {
                                                        if (i.value === res.value) {
                                                            i.open = true;
                                                        } else {
                                                            i.open = false;
                                                        }
                                                        return i;
                                                    })
                                                    return prev;
                                                });
                                            }
                                        }} style={{ float: "right", cursor: "pointer" }} />
                                    }
                                </Grid>
                            </Grid>
                            <Box className={`restrictions-exceptions-inputs ${res.open && "open"}`}>
                                <Box className={'restriction-popup-input-container '}>
                                    <Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div className='input-lebel'>Min Advance</div>
                                            <div>
                                                <Tooltip title="Restriction will not apply if the guest books this number of days or more in Advance" sx={{ mt: 0.5 }} arrow>
                                                    {customInfoIcon}
                                                </Tooltip>
                                            </div>
                                        </Box>
                                        <TextField
                                            fullWidth
                                            className='textfield'
                                            placeholder='00'
                                            // value={res.exceptions.minadvance}
                                            onChange={(e) => { }}
                                        >
                                        </TextField>
                                    </Box>
                                    <Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div className='input-lebel'>Max Advance</div>
                                            <div>
                                                <Tooltip title="Restriction will not apply if the guest books this number of days or less in Advance." sx={{ mt: 0.5 }} arrow>
                                                    {customInfoIcon}
                                                </Tooltip>
                                            </div>
                                        </Box>
                                        <TextField
                                            fullWidth
                                            className='textfield'
                                            placeholder='00'
                                            //value={res.exceptions.maxadvance}
                                            onChange={(e) => { }}
                                        >
                                        </TextField>
                                    </Box>
                                </Box>

                                <Box className='restriction-popup-input-container'>
                                    <Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div className='input-lebel'>Min Length</div>
                                            <div>
                                                <Tooltip title="Restriction will not apply if the guest stays this number or more (Nights)" sx={{ mt: 0.5 }} arrow>
                                                    {customInfoIcon}
                                                </Tooltip>
                                            </div>
                                        </Box>

                                        <TextField
                                            fullWidth
                                            className='textfield'
                                            placeholder='00'
                                            // value={res.exceptions.minlos}
                                            onChange={(e) => { }}
                                        >
                                        </TextField>
                                    </Box>
                                    <Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div className='input-lebel'>Max Length</div>
                                            <div>
                                                <Tooltip title="Restriction will not apply if guests stay this number or fewer (Nights)." sx={{ mt: 0.5 }} arrow>
                                                    {customInfoIcon}
                                                </Tooltip>
                                            </div>
                                        </Box>
                                        <TextField
                                            fullWidth
                                            className='textfield'
                                            placeholder='00'
                                            // value={res.exceptions.maxlos}
                                            onChange={(e) => { }}
                                        >
                                        </TextField>
                                    </Box>
                                </Box>

                                <Box className='restriction-popup-input-container'>
                                    <Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div className='input-lebel'>Min Price</div>
                                        </Box>
                                        <TextField
                                            fullWidth
                                            className='textfield'
                                            placeholder='00'
                                            // value={res.exceptions.minprice}
                                            onChange={(e) => { }}
                                        >
                                        </TextField>
                                    </Box>
                                    <Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div className='input-lebel'>Max Price</div>
                                        </Box>
                                        <TextField
                                            fullWidth
                                            className='textfield'
                                            placeholder='00'
                                            // value={res.exceptions.maxprice}
                                            onChange={(e) => { }}
                                        >
                                        </TextField>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )
                })}
            </Grid>
        )
    }

    const handleSaveRestrictions = (e) => {
        e.stopPropagation();
        let currRestriction = roomData?.restrictions?.user_override?.join()?.toLowerCase();
        let newRestrictions = [];
        Object.keys(entry).forEach((key) => {
            if (['cta', 'ctd', 'close', 'min_los', 'max_los'].includes(key)) {
                let valueToPush = null;
                if (key === 'cta' && entry[key]) valueToPush = 'CTA';
                if (key === 'ctd' && entry[key]) valueToPush = 'CTD';
                if (key === 'close' && entry[key]) valueToPush = 'CLS';

                if (['min_los', 'max_los'].includes(key)) {
                    //Ignore if value is less than 1 or equal to 1
                    if (key === 'min_los' && entry[key] > 1) valueToPush = 'MN ' + entry[key];
                    if (key === 'max_los' && entry[key] > 1) valueToPush = 'MX ' + entry[key];
                    // if(entry[key] <= 1) valueToPush = null;
                }
                if (valueToPush) newRestrictions.push(valueToPush);
            }
        });

        if (newRestrictions.length > 0) {
            const recommendedRest = roomData.restrictions.recommended.join()?.toLowerCase();
            const currRest = roomData.restrictions.current.join()?.toLowerCase();
            const newRestTxt = newRestrictions.join()?.toLowerCase();

            roomData.restrictions.user_override = _.cloneDeep(newRestrictions); //.splice(0, roomData?.restrictions?.user_override.length, ...newRestrictions);

            let rec_accepted = recommendedRest && recommendedRest === newRestTxt;
            let overriden = (newRestTxt !== recommendedRest) && (newRestTxt !== currRest);
            if (rec_accepted) roomData.curr_user_action = 'recommended_accepted';
            if (overriden) roomData.curr_user_action = 'overridden';
            if (!overriden && !rec_accepted) roomData.curr_user_action = '';

            roomData.showCopyMenu = true;

            // dateRowData.data.bucket_update += 1;
            // dateRowData.updateRowData(dateRowData.data);
        }
        if (!newRestrictions.length) {
            let curr = roomData?.restrictions?.current?.join()?.toLowerCase();
            let user = roomData?.restrictions?.user_override?.join()?.toLowerCase();
            roomData.restrictions.user_override = []; //.splice(0, roomData?.restrictions?.user_override.length, ...newRestrictions);
            roomData.curr_user_action = curr !== user ? 'overridden' : '';
            dateRowData.data.bucket_update += 1;
            roomData.showCopyMenu = false;
            dateRowData.updateRowData(dateRowData.data);
        }
        handleClose(roomData)
    }

    const ToggleWrapper = (props) => {
        const { allowed, children, label, dataSource } = props;
        const labelLowerCase = label.toLowerCase()
        if (allowed) {
            return children
        }
        return (
            <Tooltip title={`${dataSource} does not support "${label}"`} sx={{ mt: 0.5 }} arrow>
                <Box className={`restriction-popup-switch ${labelLowerCase} disable`} >
                    <div>{label}</div>
                </Box>
            </Tooltip>
        )
    }

    const getRestrictionLabel = (key, default_restrictions) => {
        if (!default_restrictions || typeof default_restrictions !== "object") return;
        const normalizedKey = Object.keys(default_restrictions).find(
            k => k.toLowerCase() === key.toLowerCase()
        );

        if (!normalizedKey) return;
        const value = default_restrictions[normalizedKey];
        if (value === null || value === undefined) return;

        const labelMap = {
            MinLOS: "Min LOS",
            MaxLOS: "Max LOS",
            MinAdvanceBook: "Min Advance Book",
            MaxAdvanceBook: "Max Advance Book"
        };

        const label = labelMap[normalizedKey] || normalizedKey;
        return `(Default: ${value})`;
    };

    return (
        <>
            <Modal
                className="popup-modal-wrap"
                open={modalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={`popup-modal restrictions-update-product  ${hasExceptions ? 'has-exceptions' : 'without-exceptions'}`}>
                    <Box className='modal-titlebar'>
                        <Grid container spacing={0} className={'modal restrictions-update '}>
                            <Grid className='popup-main-title' item xs={10}>
                                {/* dateFormatted = Wed, Jan 01, 2025 */}
                                <div>
                                    {/* <span>Restrictions -</span> {dateFormatted} : {ratePlanRowData?.label?.length > 40 ? ratePlanRowData?.label?.slice(0, 40) + "..." : ratePlanRowData?.label} {roomData?.room_type_code ? '| ' + roomData?.room_type_code : ''} */}
                                    <span>Restrictions -</span> {dateFormatted} : {ratePlanRowData?.rate_plan_code ? ratePlanRowData?.rate_plan_code : ''} {roomData?.room_type_code ? '| ' + roomData?.room_type_code : ''}
                                </div>
                            </Grid>
                            <Grid className='right-cta' xs={2} item alignItems="end">
                                <Button sx={{
                                    minWidth: 'auto', position: 'absolute', top: -12, right: -12, width: '24px', height: '24px', p: '7px',
                                    borderRadius: '50%', borderWidth: '1px', borderStyle: 'solid',
                                    borderColor: '#ccc', boxShadow: '0 0 4px #000', background: '#000', color: '#FFF', fontSize: '10px',
                                    '&:hover': { backgroundColor: '#000' }
                                }} onClick={handleClose}>
                                    <CloseSharpIcon fontSize='small' />
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box className="restrictions-update-popup-body">
                        <Grid className='restriction-popup-container-1' container>

                            <Box className='restriction-popup-title-1'>Restrictions</Box>

                            {/* <Box className='restriction-popup-switch-container'>
                                <Box>
                                    <Box className={compState.open ? 'restriction-popup-switch open active' : 'restriction-popup-switch open disable'} >
                                        {compState.open && <CheckmarkAnimation identifier="open" />}
                                        <div>Open</div>
                                    </Box>

                                    <small className='small-text'>Rec</small>
                                </Box>
                                <Box>
                                    <ToggleWrapper allowed={rDataLevelOptionsPermissions.cta} label='CTA' dataSource={dataSource}>
                                        <Box
                                            className={` 
                                                ${compState.entry.cta ? 'restriction-popup-switch cta active' : 'restriction-popup-switch cta'} 
                                            `}
                                            onClick={() => {
                                                updateEntry('cta')
                                            }}
                                        >
                                            {compState.entry.cta && <CheckmarkAnimation identifier="cta" />}
                                            <div>CTA</div>
                                        </Box>
                                    </ToggleWrapper>
                                    <small className='small-text'>
                                        {recommended?.includes('CTA') && 'Rec'}
                                        &nbsp;
                                    </small>
                                </Box>
                                <Box>
                                    <ToggleWrapper allowed={rDataLevelOptionsPermissions.ctd} label='CTD' dataSource={dataSource}>
                                        <Box
                                            className={`
                                                ${compState.entry.ctd ? 'restriction-popup-switch ctd active' : 'restriction-popup-switch ctd'}
                                            `}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                updateEntry('ctd')
                                            }}
                                        >
                                            {compState.entry.ctd && <CheckmarkAnimation identifier="ctd" />}
                                            <div>CTD</div>
                                        </Box>
                                    </ToggleWrapper>

                                    <small className='small-text'>
                                        {recommended?.includes('CTD') && 'Rec'}
                                        &nbsp;
                                    </small>

                                </Box>
                                <Box>
                                    <ToggleWrapper allowed={rDataLevelOptionsPermissions.close} label='Close' dataSource={dataSource}>
                                        <Box className={`
                                                ${compState.entry.close ? 'restriction-popup-switch close active' : 'restriction-popup-switch close'}
                                            `}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                updateEntry('close')
                                            }}
                                        >
                                            {compState.entry.close && <CheckmarkAnimation identifier="close" />}
                                            <div>Close</div>
                                        </Box>
                                    </ToggleWrapper>
                                    <small className='small-text'>
                                        {recommended?.includes('CLS') && 'Rec'}
                                        &nbsp;
                                    </small>
                                </Box>
                            </Box> */}

                            <Box className="restriction-popup-switch-container-new">
                                <Box>
                                    <button
                                        className={`restriction-switch open ${compState.open ? "active" : "disabled"}`}
                                    >
                                        <span className="checkmark">
                                            <svg viewBox="0 0 24 24">
                                                <path
                                                    d="M4 12l6 6L20 6"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                />
                                            </svg>
                                        </span>
                                        <span className="label">Open</span>
                                    </button>
                                    <small className='small-text'>Rec</small>
                                </Box>

                                <Box>
                                    <button
                                        className={`restriction-switch cta ${compState.entry.cta ? "active" : ""}`}
                                        onClick={() => updateEntry('cta')}
                                    >
                                        <span className="checkmark">
                                            <svg viewBox="0 0 24 24">
                                                <path
                                                    d="M4 12l6 6L20 6"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                />
                                            </svg>
                                        </span>
                                        <span className="label">CTA</span>
                                    </button>
                                    <small className='small-text'>
                                        {recommended?.includes('CTA') && 'Rec'}
                                        &nbsp;
                                    </small>
                                </Box>

                                <Box>
                                    <button
                                        className={`restriction-switch ctd ${compState.entry.ctd ? "active" : ""}`}
                                        onClick={() => updateEntry('ctd')}
                                    >
                                        <span className="checkmark">
                                            <svg viewBox="0 0 24 24">
                                                <path
                                                    d="M4 12l6 6L20 6"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                />
                                            </svg>
                                        </span>
                                        <span className="label">CTD</span>
                                    </button>
                                    <small className='small-text'>
                                        {recommended?.includes('CTD') && 'Rec'}
                                        &nbsp;
                                    </small>
                                </Box>

                                <Box>
                                    <button
                                        className={`restriction-switch close ${compState.entry.close ? "active" : ""}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            updateEntry('close')
                                        }}
                                    >
                                        <span className="checkmark">
                                            <svg viewBox="0 0 24 24">
                                                <path
                                                    d="M4 12l6 6L20 6"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                />
                                            </svg>
                                        </span>
                                        <span className="label">Close</span>
                                    </button>
                                    <small className='small-text'>
                                        {recommended?.includes('CLS') && 'Rec'}
                                        &nbsp;
                                    </small>
                                </Box>
                            </Box>

                            {!hasExceptions ?
                                <Box className='restriction-popup-input-container' mt={0.5}>
                                    <Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div className='input-lebel'>
                                                Min LOS {getRestrictionLabel("minlos", ratePlanRowData?.default_restrictions)}
                                            </div>
                                            <div>
                                                <Tooltip
                                                    title={
                                                        rDataLevelOptionsPermissions.los_min
                                                            ? `Enter '0' to remove LOS`
                                                            : `${dataSource} does not support "Min LOS"`
                                                    }
                                                    sx={{ mt: 0.5 }}
                                                    arrow
                                                >
                                                    {customInfoIcon}
                                                </Tooltip>
                                            </div>
                                        </Box>
                                        <TextField
                                            fullWidth
                                            className='textfield colord2'
                                            disabled={!rDataLevelOptionsPermissions.los_min || ratePlanRowData?.default_restrictions?.MinLOS} 
                                            value={compState.entry.min_los}
                                            defaultValue={compState.entry.min_los}
                                            onBlur={(e) => { 
                                                const default_min_los = ratePlanRowData?.default_restrictions?.MinLOS ;
                                                const input_min_los = Number(e.target.value);
                                                if (default_min_los && input_min_los < default_min_los ) {
                                                    handleOnChangeText('min_los')({ target: { value: default_min_los } });
                                                }
                                            }}
                                            onChange={handleOnChangeText('min_los')}
                                        >
                                        </TextField>
                                        <small className='small-text'>
                                            {recommended?.join().includes('MN ') && 'Rec: ' + recommended.find(item => item.startsWith('MN ')).split(' ')[1]}
                                            &nbsp;
                                        </small>
                                        {/* <small className='small-text'>Rec: 2</small> */}
                                    </Box>
                                    <Box>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <div className='input-lebel'>
                                                Max LOS {getRestrictionLabel("maxlos", ratePlanRowData?.default_restrictions)}
                                            </div>
                                            <div>
                                                <Tooltip
                                                    title={`
                                                        ${rDataLevelOptionsPermissions.los_max ?
                                                            `Enter '0' to remove LOS`
                                                            :
                                                            `${dataSource} does not support "Max LOS"`
                                                        }
                                                    `}
                                                    sx={{ mt: 0.5 }} arrow>
                                                    {customInfoIcon}
                                                </Tooltip>
                                            </div>
                                        </Box>
                                        <TextField
                                            fullWidth
                                            className='textfield colord1'
                                            disabled={!rDataLevelOptionsPermissions.los_max}
                                            // defaultValue={compState.entry.max_los || 3}

                                            value={compState.entry.max_los}
                                            defaultValue={compState.entry.max_los}

                                            onBlur={(e) => { 
                                                const default_max_los = ratePlanRowData?.default_restrictions?.MaxLOS ;
                                                const input_max_los = Number(e.target.value);
                                                if (default_max_los && input_max_los > default_max_los || input_max_los <= 1 ) {
                                                    handleOnChangeText('max_los')({ target: { value: default_max_los } });
                                                  }
                                            }}
                                            onChange={handleOnChangeText('max_los')}
                                        >
                                        </TextField>
                                        <small className='small-text'>
                                            {recommended?.join().includes('MX ') && ('Rec: ' + recommended.find(item => item.startsWith('MX ')).split(' ')[1])}
                                            &nbsp;
                                        </small>

                                    </Box>
                                </Box>
                                :
                                <Box className="restrictions-exceptions-box">
                                    {hasExceptions && (
                                        <>
                                            {renderExceptions()}
                                            <div className="info-text">
                                                If you do not wish to apply any exceptions, please leave them blank.
                                            </div>
                                        </>
                                    )}
                                </Box>
                            }
                        </Grid>
                    </Box>

                    <Box className="restrictions-update-popup-footer">
                        <Button
                            className="navigate-cancel-button btn-active"
                            variant="outlined"
                            size="small"
                            sx={{ minWidth: "auto" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleClose(roomData)
                            }
                            }
                        >
                            Cancel
                        </Button>

                        <Button
                            disabled={!compState.modified}
                            className={(compState.modified) ? "navigate-save-button btn-active" : "navigate-save-button"}
                            variant="outlined"
                            size="small"
                            sx={{ minWidth: "auto", mr: 1, color: "white.main" }}
                            onClick={handleSaveRestrictions}
                        >
                            Save
                        </Button>
                    </Box>

                </Box>
            </Modal>
        </>
    )

}

const CheckmarkAnimation = ({ identifier }) => {
    const pathRef = useRef(null);
    const [active, setActive] = useState(animatedFlags[identifier] || false);

    useEffect(() => {
        if (!animatedFlags[identifier]) {
            const timeout = setTimeout(() => {
                setActive(true);
                animatedFlags[identifier] = true; // Mark as animated
            }, 100);

            return () => clearTimeout(timeout);
        }
    }, [identifier]);

    return (
        <svg
            viewBox="0 0 15 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            width={15}
            height={15}
        >
            <path
                id="checkmark"
                ref={pathRef}
                d="M1.5 6.5L5 10L13.5 1.5"
                stroke="#606060"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={active ? 'active' : ''}
            />
        </svg>
    );
};


